import _asyncToGenerator from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js";
import { EventEmitter } from "events";
import fetch from "cross-fetch";
import { safeJsonParse, safeJsonStringify } from "@walletconnect/safe-json";
import { formatJsonRpcError, isHttpUrl, parseConnectionError } from "@walletconnect/jsonrpc-utils";
var DEFAULT_HTTP_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
var DEFAULT_HTTP_METHOD = "POST";
var DEFAULT_FETCH_OPTS = {
  headers: DEFAULT_HTTP_HEADERS,
  method: DEFAULT_HTTP_METHOD
};
export var HttpConnection = /*#__PURE__*/function () {
  function HttpConnection(url) {
    _classCallCheck(this, HttpConnection);

    this.url = url;
    this.events = new EventEmitter();
    this.isAvailable = false;
    this.registering = false;

    if (!isHttpUrl(url)) {
      throw new Error("Provided URL is not compatible with HTTP connection: ".concat(url));
    }

    this.url = url;
  }

  _createClass(HttpConnection, [{
    key: "connected",
    get: function get() {
      return this.isAvailable;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.registering;
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.url;
                _context.next = 3;
                return this.register(url);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isAvailable) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Connection already closed");

              case 2:
                this.onClose();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, context) {
        var body, res, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.isAvailable) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.register();

              case 3:
                _context3.prev = 3;
                body = safeJsonStringify(payload);
                _context3.next = 7;
                return fetch(this.url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), {
                  body: body
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 10;
                return res.json();

              case 10:
                data = _context3.sent;
                this.onPayload({
                  data: data
                });
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](3);
                this.onError(payload.id, _context3.t0);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 14]]);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var url,
            body,
            error,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : this.url;

                if (isHttpUrl(url)) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("Provided URL is not compatible with HTTP connection: ".concat(url));

              case 3:
                if (!this.registering) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  _this.events.once("register_error", function (error) {
                    reject(error);
                  });

                  _this.events.once("open", function () {
                    if (typeof _this.isAvailable === "undefined") {
                      return reject(new Error("HTTP connection is missing or invalid"));
                    }

                    resolve();
                  });
                }));

              case 5:
                this.url = url;
                this.registering = true;
                _context4.prev = 7;
                body = safeJsonStringify({
                  id: 1,
                  jsonrpc: "2.0",
                  method: "test",
                  params: []
                });
                _context4.next = 11;
                return fetch(url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), {
                  body: body
                }));

              case 11:
                this.onOpen();
                _context4.next = 20;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](7);
                error = this.parseError(_context4.t0);
                this.events.emit("register_error", error);
                this.onClose();
                throw error;

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[7, 14]]);
      }));

      function register() {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "onOpen",
    value: function onOpen() {
      this.isAvailable = true;
      this.registering = false;
      this.events.emit("open");
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.isAvailable = false;
      this.registering = false;
      this.events.emit("close");
    }
  }, {
    key: "onPayload",
    value: function onPayload(e) {
      if (typeof e.data === "undefined") return;
      var payload = typeof e.data === "string" ? safeJsonParse(e.data) : e.data;
      this.events.emit("payload", payload);
    }
  }, {
    key: "onError",
    value: function onError(id, e) {
      var error = this.parseError(e);
      var message = error.message || error.toString();
      var payload = formatJsonRpcError(id, message);
      this.events.emit("payload", payload);
    }
  }, {
    key: "parseError",
    value: function parseError(e) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.url;
      return parseConnectionError(e, url, "HTTP");
    }
  }]);

  return HttpConnection;
}();
export default HttpConnection;